module.exports = __webpack_public_path__ + "data-table.bce071e976865da51100.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-datatable/release/assets/fonts/data-table.eot
// module id = 277
// module chunks = 15